import request from '@/utils/request'

export function store(data) {
  return request({
    url: 'zone/store',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: 'zone/update',
    method: 'put',
    data
  })
}

export function getAll() {
  return request({
    url: 'zone/zones',
    method: 'get'
  })
}

export function getById(id) {
  return request({
    url: 'zone/getById/' + id,
    method: 'get'
  });
}

export function deleteData(id) {
  return request({
    url: 'zone/destroy/' + id,
    method: 'delete'
  });
}